import r, { OPTIONS as z } from "../managers/braze-instance.js";
import ro from "../util/browser-detector.js";
import nr from "./l10n-manager.js";
const fe = {
  l: !1,
  aa: null,
  ea: () => {
    if ((fe.p(), !fe.aa)) {
      let e = ro.language,
        t = !1;
      r.ee(z.Zn) && ((e = r.ee(z.Zn)), (t = !0)), (fe.aa = new nr(e, t));
    }
    return fe.aa;
  },
  p: () => {
    fe.l || (r.h(fe), (fe.l = !0));
  },
  destroy: () => {
    (fe.aa = null), (fe.l = !1);
  },
};
export default fe;
